export default __webpack_public_path__ + "static/media/user-management.e76d6a25.svg";